import { lazy } from 'react';

export const VendorList = lazy(() => import('./vendor/VendorList'));
export const AddVendor = lazy(() => import('./vendor/AddVendor'));
export const UpdateVendor = lazy(() => import('./vendor/UpdateVendor'));